import React from 'react';
import { Skeleton } from '@chakra-ui/react';
import {
  HStack,
  VStack,
} from '@ayble-health/dashboard-components';

export const MeetingTypePickerSkeleton = () => (
  <HStack>
    <HStack flex={3} gap={3}>
      <VStack flex={1} gap={3}>
        <Skeleton borderRadius={'8px'} height={'48px'} />
        <Skeleton borderRadius={'8px'} height={'48px'} />
      </VStack>

      <VStack flex={1} gap={3}>
        <Skeleton borderRadius={'8px'} height={'48px'} />
        <Skeleton borderRadius={'8px'} height={'48px'} />
      </VStack>
    </HStack>

    <HStack flex={{ base: 0, lg: 2 }} />
  </HStack>
);
